import { IconButton, IconButtonTypeMap } from "@mui/material";
import * as React from "react";
import { OverrideProps } from "@mui/material/OverridableComponent";
import { Theme, useTheme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

export const taxGuruIconButtonSx = {
    borderStyle: "solid",
    borderWidth: "2px",
    borderRadius: "5px",
};

const taxGuruIconButtonContained = (theme: Theme, disabled: boolean | undefined) => ({
    borderRadius: "5px",
    height: "38px",
    width: "38px",
    background: theme.palette.primary.main,
    "&:hover": {
        backgroundColor: theme.palette.primary.dark,
    },
    "& svg": {
        color: disabled ? "inherit" : "white",
    },
    ...(disabled && taxGuruIconButtonSx),
});

export type IconButtonProps = OverrideProps<
    IconButtonTypeMap<unknown, IconButtonTypeMap["defaultComponent"]>,
    IconButtonTypeMap["defaultComponent"]
> & {
    withFrame?: boolean;
    variant?: "contained";
    shape?: "square";
};
const TaxGuruIconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(function TaxGuruIconButton(props, ref) {
    const { sx, variant, shape, withFrame = false, disabled, ...other } = props;
    const theme = useTheme();
    const sxProps: SystemStyleObject<Theme> | undefined = typeof sx === "function" ? sx(theme) : (sx as SystemStyleObject<Theme>);
    return (
        <IconButton
            color="secondary"
            ref={ref}
            disabled={disabled}
            sx={(theme) => ({
                ...(variant === "contained" && taxGuruIconButtonContained(theme, disabled)),
                ...sxProps,
                ...(withFrame && taxGuruIconButtonSx),
                ...(shape === "square" && {
                    borderRadius: 0,
                    ".MuiTouchRipple-ripple .MuiTouchRipple-child": {
                        borderRadius: 0,
                    },
                }),
            })}
            {...other}
        />
    );
});

export default TaxGuruIconButton;
